export default __webpack_public_path__ + "assets/instagram.4a0481b3.svg";